export default "__VITE_ASSET__BKP2nhUH__"